// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BusinessManagerSwitchLoader{position:fixed;top:50%;left:55%}\n", ""]);
// Exports
module.exports = exports;
